// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__5IaYM","opacity-transition":"success_opacity-transition__6bfz3"};